{
  "page.title":       "Przewodnik Via Baltica — Marek Jeziak, Gdańsk",
  "page.description": "Prywatne wycieczki z licencjonowanym przewodnikiem Markiem Jeziakiem po Gdańsku. Po angielsku i polsku. Zarezerwuj swoją przygodę nad Bałtykiem.",

  "drawer.back": "Wróć",
  "nav.home":      "Strona główna",
  "nav.tours":     "Wycieczki",
  "nav.about":     "O nas",
  "nav.reviews":   "Opinie",
  "nav.faq":       "FAQ",
  "nav.contact":   "Kontakt",
  "nav.blog":      "Blog",
  "nav.cta":       "Zarezerwuj wycieczkę",

  "hero.badge":     "Prywatne wycieczki · Gdańsk i Pomorze",
  "hero.heading":   "Odkryj duszę<br><em>Morza Bałtyckiego</em>",
  "hero.body":      "Prywatne wycieczki z przewodnikiem po jednym z najpiękniejszych miast bałtyckich Europy — gdzie historia, bursztyn i morze tworzą niepowtarzalną całość.",
  "hero.cta":       "Odkryj wycieczki",
  "hero.secondary": "Poznaj przewodnika",
  "hero.stat1":     "Lat doświadczenia",
  "hero.stat2":     "Ocena Google",
  "hero.stat3":     "Unikalnych tras",
  "hero.stat4":     "Języki",

  "about.badge":            "Twój przewodnik",
  "about.heading":          "Niektóre miasta się zwiedza. <em>Gdańsk się rozumie.</em>",
  "about.p1":               "Jestem gdańszczaninem — zanurzonym w historii najpotężniejszego portu Bałtyku. Przez lata odkrywałem to, co leży pod powierzchnią: opowieści ukryte w kamieniach, znaczenia wpisane w pomniki, codzienną duszę miasta, które kształtowało imperia i zmieniało świat. Znam zaułki gdańskich ulic, sopockie plaże i gdyński port. Na filarach historii buduję współczesną opowieść o Trójmieście. Jako mieszkaniec — znam istotę tego miejsca. Jako przewodnik — dzielę się tym, co to poznawanie odsłoniło.",
  "about.p2":               "Jestem licencjonowanym przewodnikiem i pilotem wycieczek, certyfikowanym przez Polskie Towarzystwo Turystyczno-Krajoznawcze (PTTK). Pracuję z grupami każdego wieku i rodzaju. Zarówno z podróżnikiem tropicym hanzeatycką przeszłość, rodziną odkrywającą Solidarność po raz pierwszy, jak i z uczniami, dla których historia musi ożyć — szukam tej jednej opowieści, przy której każdy gość zatrzymuje się, unosi głowę i naprawdę rozumie.",
  "about.polaroid_caption": "Marek, na Długim Pobrzeżu",
  "about.polaroid_location":"Gdańsk · Wybrzeże Bałtyku",
  "about.placeholder":      "Zastąp zdjęciem Marka w terenie",
  "about.h1title":          "Licencjonowany przewodnik",
  "about.h1desc":           "Polskie Towarzystwo Turystyczno-Krajoznawcze (PTTK), Gdańsk. Ceniony przez najlepszych operatorów turystycznych w Polsce.",
  "about.h2title":          "Angielski i polski",
  "about.h2desc":           "Rodzimy język: polski, biegły angielski. ",
  "about.h3title":          "Urodzony w Gdańsku",
  "about.h3desc":           "Urodzony na Wybrzeżu Bałtyckim, ukształtowany przez jego historię. Każdy zaułek, legenda i stoczniowa opowieść są częścią mnie.",
  "about.h4title":          "{rating} w Google",
  "about.h4desc":           "{n} opinii, same pięć gwiazdek. Sprawdź, co piszą podróżnicy.",
  "about.ctaTours":         "Przeglądaj wycieczki →",

  "trips.badge":             "Odkryj Gdańsk",
  "trips.heading":           "Przeglądaj wycieczki",
  "trips.subheading":        "Przesuń w każdym wierszu, aby odkryć wszystkie trasy.",
  "trips.book":              "Zarezerwuj wycieczkę",
  "trips.tours":             "tras",
  "trips.from":              "od",
  "trips.from_group":        "Cena / grupa",
  "trips.prev":              "Poprzednia",
  "trips.next":              "Następna",
  "trips.drawer_label":      "Szczegóły wycieczki",
  "trips.drawer_close":      "Zamknij",
  "trips.highlights":        "Co zobaczymy",
  "trips.cancellation":      "Bezpłatne odwołanie do 48 h.",
  "trips.cancellation_note": "Bez płatności z góry — potwierdzenie e-mailem.",

  "blog.page_title": "Blog — Via Baltica",
  "blog.badge":      "Z notatnika Marka",
  "blog.heading":    "Historie z Gdańska",
  "blog.read_more":  "Czytaj więcej →",
  "blog.back":       "← Wszystkie wpisy",
  "blog.empty":      "Brak wpisów.",
  "blog.by":         "Autor:",
  "blog.min_read":   "min czytania",

  "faq.eyebrow":  "Warto wiedzieć",
  "faq.title":    "Najczęstsze pytania",
  "faq.subtitle": "Kilka rzeczy, o które podróżnicy zwykle pytają przed rezerwacją. Cokolwiek innego — po prostu napisz.",
  "faq.q1": "Jak kalkulowane są ceny wycieczek?",
  "faq.a1": "Ceny dotyczą całej grupy, nie osoby — para płaci tyle samo co pięcioosobowa rodzina. Podane ceny to punkt wyjścia dla grup do 4 osób; większe grupy i dłuższe trasy wyceniam indywidualnie. Dzieci do 12 lat gratis.",
  "faq.q2": "Jaka jest polityka anulowania?",
  "faq.a2": "Możesz zrezygnować z dowolnego powodu do 48 godzin przed wycieczką i otrzymać pełny zwrot. Odwołania z powodu pogody są moją decyzją i zawsze bezpłatne — możemy przełożyć termin lub zwrócić pieniądze.",
  "faq.q3": "Skąd startują i gdzie kończą się wycieczki?",
  "faq.a3": "Większość wycieczek startuje przy Fontannie Neptuna na Długim Targu. Mogę też odebrać cię z hotelu w centrum Gdańska, Sopotu lub Gdyni. Wycieczki nadbrzeżne i jednodniowe obejmują transport spod hotelu.",
  "faq.q4": "W jakich językach prowadzi Pan wycieczki?",
  "faq.a4": "Wycieczki są prowadzone w języku polskim i angielskim. Prosimy o wskazanie preferowanego języka podczas dokonywania rezerwacji, abyśmy mogli odpowiednio przygotować wycieczkę.",
  "faq.q5": "Czy wycieczki są dostępne dla rodzin z dziećmi?",
  "faq.a5": "Trasy po Starym Mieście wiodą przez brukowane uliczki i kilka schodów, ale są spokojne i można swobodnie dostosować tempo. Trasa rodzinna jest w pełni dostępna dla wózków. Powiedz mi o potrzebach grupy, a dostosuję spacer.",
  "faq.q6": "Czy oferuje Pan trasy na zamówienie?",
  "faq.a6": "Zawsze. Mniej więcej jedna trzecia moich rezerwacji to wycieczki szyte na miarę — tematyczne wokół kuchni, fotografii, historii Solidarności czy poszukiwań rodzinnych korzeni. Napisz, co cię interesuje.",
  "faq.q7": "Czy zapewnia Pan transport na wycieczki całodniowe?",
  "faq.a7": "Tak — mam własny samochód i korzystam z niego na wszystkich prywatnych wyprawach poza Gdańsk. Wycieczka samochodem to świetny sposób na odkrycie nowych miejsc, gdy czas jest ograniczony — a jednocześnie doskonała okazja, by wyrwać się z codzienności: jeden dzień, jedna podróż, najlepsze z Pomorza we własnym tempie. Odbiór spod hotelu jest wliczony we wszystkich wycieczkach całodniowych. Malbork, Kaszuby, Toruń, Kanał Elbląski — wystarczy napisać, dokąd chcesz pojechać.",

  "reviews.badge":    "Co mówią podróżnicy",
  "reviews.heading":  "Zaufali nam podróżnicy",
  "reviews.count":        "(18 opinii)",
  "reviews.count_format": "({n} opinii)",
  "reviews.cta":      "Czytaj wszystkie opinie w Google →",
  "reviews.r1.text":  "Marek to wyjątkowy przewodnik — pełen wiedzy, pasji i zaangażowania. Wycieczka Via Baltica przerosła wszelkie oczekiwania. Gorąco polecam!",
  "reviews.r1.date":  "Marzec 2025",
  "reviews.r2.text":  "Fantastyczne doświadczenie w Gdańsku. Marek ożywia historię w sposób, jakiego żaden podręcznik nie jest w stanie oddać. Wrócimy na kolejną wycieczkę!",
  "reviews.r2.date":  "Styczeń 2025",
  "reviews.r3.text":  "Jedna z najlepszych wycieczek z przewodnikiem, jaką miałam w Europie. Trasa Via Baltica była perfekcyjnie zaplanowana, a opowieści Marka sprawiły, że każdy przystanek był niezapomniany.",
  "reviews.r3.date":  "Grudzień 2024",

  "contact.badge":       "Zarezerwuj wycieczkę",
  "contact.heading":     "Zarezerwuj swoją<br>gdańską <em>przygodę</em>",
  "contact.body":        "Nie znalazłeś tego, czego szukasz? Napisz mi, co chciałbyś zobaczyć — załatwię to. Skontaktuj się bezpośrednio, a Marek odpowie w ciągu 24 godzin.",
  "contact.phone.label": "Telefon",
  "contact.email.label": "Email",
  "contact.hours.label": "Dostępność",
  "contact.hours.value": "Codziennie · 08:00 – 20:00",
  "contact.lang.label":  "Języki",
  "contact.lang.value":  "Angielski i Polski",
  "contact.note":        "Wycieczki prywatne · Trasy na zamówienie · Grupy mile widziane",

  "footer.tagline":         "Osiemnaście lat odkrywania ulic, historii i ukrytych podwórek, których większość turystów nigdy nie widzi.",

  "footer.col.tours":       "Wycieczki",
  "footer.col.explore":     "Odkryj",
  "footer.col.reach":       "Kontakt",

  "footer.tours.all":       "Wszystkie wycieczki",
  "footer.tours.gdansk":    "Spacery po Gdańsku",
  "footer.tours.coast":     "Wycieczki rowerowe",
  "footer.tours.nature":    "Wycieczki całodniowe",
  "footer.tours.book":      "Zarezerwuj wycieczkę",

  "footer.explore.about":   "Poznaj Marka",
  "footer.explore.reviews": "Opinie podróżników",
  "footer.explore.faq":     "Najczęstsze pytania",
  "footer.explore.blog":    "Z notatnika Marka",

  "footer.reach.address":   "Długie Ogrody 2/31",
  "footer.reach.location":  "80-765 Gdańsk, Polska",

  "footer.copyright":       "© {year} Tour Guides VIA BALTICA · Marek Jeziak. Wszelkie prawa zastrzeżone.",
  "footer.signature":       "Stworzone z pasją w Gdańsku"
}
